
import React from 'react';
import PackageCard from './PackageCard';
import { PackageOption } from '../../types/packageTypes';

interface PackageGridProps {
  packages: PackageOption[];
  selectedPackage: string | null;
  initialPackage: string | null;
  onPackageSelect: (packageId: string) => void;
}

const PackageGrid: React.FC<PackageGridProps> = ({
  packages,
  selectedPackage,
  initialPackage,
  onPackageSelect
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {packages.map((pkg) => (
        <PackageCard 
          key={pkg.id}
          pkg={pkg}
          selectedPackage={selectedPackage}
          initialPackage={initialPackage}
          onSelect={onPackageSelect}
          packageOptions={packages}
        />
      ))}
    </div>
  );
};

export default PackageGrid;
